import { useQuery } from "@tanstack/react-query";
import creativeStudioApiClient, {
  CreativeJob,
  CreativeJobStatus,
} from "../creativeStudio";

export const CREATIVE_JOBS_QUERY_KEY = ["creative-jobs"];

const FINISHED_STATUSES: CreativeJobStatus[] = ["done", "failed"];

export const isCreativeJobFinished = (job: CreativeJob) =>
  FINISHED_STATUSES.includes(job.status);

/**
 * The newest Creative Studio jobs. Polls every 5 s while a job is still
 * working, and every 30 s otherwise (to pick up jobs started by others).
 */
const useCreativeJobsQuery = (limit = 50) =>
  useQuery({
    queryKey: [...CREATIVE_JOBS_QUERY_KEY, limit],
    queryFn: () => creativeStudioApiClient.getJobs(limit),
    refetchInterval: (query) =>
      query.state.data?.some((job) => !isCreativeJobFinished(job))
        ? 5_000
        : 30_000,
  });

export default useCreativeJobsQuery;
